import react, { useEffect, useState } from "react";
import fetchWithAuth from "../../../services/fetchWithAuth";
import config from "../../../config";
import { ActiveFundraiserForParticipant } from "../../../Interfaces/AccountUsers";
import { useNavigate } from "react-router-dom";
import ShareButton from "../../Storefront/ShareStoreComponent";

interface ActiveFundraisersForParticipantsTableProps {
  account_id: number;
}

const ActiveFundraisersForParticipantsTable: React.FC<
  ActiveFundraisersForParticipantsTableProps
> = ({ account_id }) => {
  const [fundraiserParticipants, setFundraiserParticipants] = useState<
    ActiveFundraiserForParticipant[]
  >([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchActiveFundraisers = async () => {
      const response = await fetchWithAuth(
        `${config.API_BASE_URL}account/${account_id}/active-fundraisers/`
      );
      const data = await response.json();
      setFundraiserParticipants(data);
    };
    fetchActiveFundraisers();
  }, []);

  const handleShare = (participant: ActiveFundraiserForParticipant) => {
    // TODO: implement share logic
    console.log("Share clicked for:", participant);
  };

  const handleView = (participant: ActiveFundraiserForParticipant) => {
    navigate(`/participant-shop/part-id/${participant.participant_code}`);
  };

  const formatDate = (dateStr: string): string => {
    const date = new Date(dateStr);
    return date.toLocaleDateString(undefined, {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const tableStyles: { [key: string]: React.CSSProperties } = {
    container: {
      border: "1px solid #ddd",
      borderRadius: "8px",
      overflow: "hidden",
      margin: "2rem auto",
      maxWidth: "1000px",
      boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse", // This is now directly used without the cast
      textAlign: "center", // No need for cast as TypeScript understands 'center' here
    },
    thTd: {
      padding: "1rem",
      borderBottom: "1px solid #eee",
    },
    thead: {
      backgroundColor: "#f9f9f9",
    },
    th: {
      fontWeight: 600,
      letterSpacing: "0.5px",
      textTransform: "uppercase",
      color: "#333",
    },
    noData: {
      padding: "1.5rem",
      fontStyle: "italic",
      textAlign: "center",
    },
    button: {
      backgroundColor: "#007bff", // Blue background
      color: "#fff", // White text color
      border: "none", // No border
      padding: "0.5rem 1rem", // Padding for the button
      fontSize: "1rem", // Font size
      borderRadius: "5px", // Rounded corners
      cursor: "pointer", // Change cursor to pointer on hover
      transition: "background-color 0.3s", // Smooth background color change on hover
    },
    buttonHover: {
      backgroundColor: "#0056b3", // Darker blue for hover
    },
    tableHeader: {
      alignItems: "center",
      textAlign: "center",
    },
  };

  return (
    <div style={tableStyles.container}>
      <h1 style={tableStyles.tableHeader}>Fundraisers in Progress</h1>
      <table style={tableStyles.table}>
        <thead style={tableStyles.thead}>
          <tr>
            <th style={tableStyles.th}>Participant Name</th>
            <th style={tableStyles.th}>Fundraiser Name</th>
            <th style={tableStyles.th}>Fundraiser End Date</th>
            <th style={tableStyles.th}>Participant Code</th>
            <th style={tableStyles.th}>Share Store</th>
            <th style={tableStyles.th}>View Store</th>
          </tr>
        </thead>
        <tbody>
          {fundraiserParticipants.length > 0 ? (
            fundraiserParticipants.map((participant) => (
              <tr key={participant.id}>
                <td style={tableStyles.thTd}>{participant.participant_name}</td>
                <td style={tableStyles.thTd}>{participant.fundraiser_name}</td>
                <td style={tableStyles.thTd}>
                  {formatDate(participant.fundraiser_end_date)}
                </td>
                <td style={tableStyles.thTd}>{participant.participant_code}</td>
                <td style={tableStyles.thTd}>
                  <ShareButton
                    participantID={participant.participant_code}
                    participantName={participant.participant_name}
                    organizationName={participant.fundraiser_name}
                    style={tableStyles.button}
                  />
                </td>
                <td style={tableStyles.thTd}>
                  <button
                    style={tableStyles.button}
                    onClick={() => handleView(participant)}
                  >
                    View Store
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={6} style={tableStyles.noData}>
                No active fundraisers to display right now.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ActiveFundraisersForParticipantsTable;
